// extracted by mini-css-extract-plugin
module.exports = {"container":"NUgnz","disabled":"_3fv2V","avatar":"_2rgps","fakeInput":"_1Uitk","placeholder":"_14c-a"};